import React from "react";
import { FlagIcon, FlagIconCode } from "react-flag-kit";
import novaLogo from "../assets/images/novaLogoMain.png";
import mapNova from "../assets/images/mapNova.png";
import { useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const StartPage: React.FC = () => {
  const countries = [
    { name: "Deutsch", code: "DE", link: "https://novamedshop.de/" },
    { name: "Nederlands", code: "NL", link: "https://novamedshop.nl/" },
    { name: "Français", code: "FR", link: "https://novamedshop.fr/" },
    { name: "Polski", code: "PL", link: "https://novamedshop.pl/" },
    { name: "Belgium", code: "BE", link: "https://novamedshop.be/" },
    { name: "Schweiz", code: "CH", link: "https://novamedshop.ch/" },
    { name: "Čeština", code: "CZ", link: "https://novamedshop.cz/" },
    { name: "Italiano", code: "IT", link: "https://novamedshop.it/" },
    { name: "Dansk", code: "DK", link: "https://novamedshop.dk/" },
    { name: "Austria", code: "AT", link: "https://novamedshop.at/" },
    { name: "Svenska", code: "SE", link: "https://novamedshop.se/" },
    { name: "Español", code: "ES", link: "https://novamedshop.es/" },
    { name: "United Kingdom", code: "GB", link: "https://novamedshop.co.uk/" },
    //{ name: "European Union", code: "EU", link: "https://novamedshop.eu/" },
    { name: "Generel Web Site", code: "US", link: "https://novamedshop.com/" },
  ];

  const navigate = useNavigate();

  const renderCountry = (country: (typeof countries)[0]) => {
    const isUS = country.code === "US";
    return (
      <a
        key={country.code}
        href={isUS ? undefined : country.link}
        onClick={isUS ? () => navigate("/") : undefined}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col justify-center items-center w-[90px] h-[100px] rounded-md shadow-md transform transition-all duration-300 cursor-pointer group hover:scale-105 hover:shadow-xl hover:bg-[#ffb8311a] bg-[#131a32]"
      >
        {isUS ? (
          <FaHome
            size={36}
            className="text-gray-200 transition-transform duration-300 group-hover:-translate-y-1 group-hover:text-[#FFB831]"
          />
        ) : (
          <FlagIcon
            code={country.code as FlagIconCode}
            size={45}
            className="transition-transform duration-300 group-hover:-translate-y-1"
          />
        )}
        <p className="mt-3 text-sm font-semibold text-center text-gray-200 transition-colors duration-300 group-hover:text-gray-700">
          {country.name}
        </p>
      </a>
    );
  };

  return (
    <div className="bg-[#fbf8f6] flex flex-col min-h-[100dvh] relative">
      {/* Harita */}
      <div className="flex justify-center mt-10">
        <img
          className="h-[400px] w-full max-w-[80%] md:max-w-[40%] object-cover border-2 rounded-xl mb-8"
          src={mapNova}
          alt="mapNova"
        />
      </div>

      {/* Masaüstü Logo */}
      <div className="hidden md:flex justify-center items-center">
        <img
          onClick={() => navigate("/")}
          className="w-[300px] md:w-[320px] mt-4 ml-10 mb-10 cursor-pointer hover:scale-105 transition-all"
          src={novaLogo}
          alt="novaLogo"
        />
      </div>

      {/* Bayraklar Grid */}
      <div className="w-full px-4 mb-16">
        <div
          className="
            grid 
            grid-cols-2 
            sm:grid-cols-3 
            md:grid-cols-7 
            gap-4 
            md:gap-6 
            xl:gap-8 
            place-items-center 
            w-full 
            md:w-10/12 
            xl:w-9/12 
            2xl:w-8/12 
            mx-auto 
            animate-fade-in
            overflow-x-auto
            min-w-[300px]
          "
        >
          {countries.map(renderCountry)}
        </div>
      </div>

      {/* Mobil Logo */}
      <div className="md:hidden bg-white fixed bottom-0 py-3 left-0 right-0 flex justify-center items-center z-50">
        <img
          onClick={() => navigate("/")}
          className="w-[240px] cursor-pointer hover:scale-105 transition-all"
          src={novaLogo}
          alt="novaLogo"
        />
      </div>
    </div>
  );
};

export default StartPage;
